import React, { useEffect, useState } from "react"
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "src/components/ui/sheet"
import { Button } from "src/components/ui/button"
import { useToast } from "src/components/ui/toast"
import { ChannelPartnerBasicsTab } from "./ChannelPartnerBasicsTab"
import { useCreateChannelPartner, useUpdateChannelPartner } from "../hooks/useChannelPartners"

export function ChannelPartnerDrawer({ open, partner, onClose, onSuccess }) {
  const { toast } = useToast()
  const isEdit = Boolean(partner?.id)
  const [form, setForm] = useState({})
  const createHook = useCreateChannelPartner()
  const updateHook = useUpdateChannelPartner()

  useEffect(() => {
    if (open) {
      setForm(
        partner
          ? { ...partner }
          : { name: "", company_name: "", email: "", phone: "", rera_number: "", status: "active", referral_code: "", commission_type: "percent", commission_value: "" }
      )
    }
  }, [open, partner])

  async function handleSave() {
    try {
      const payload = {
        name: form.name,
        company_name: form.company_name,
        email: form.email,
        phone: form.phone,
        rera_number: form.rera_number,
        status: form.status,
        referral_code: form.referral_code,
        commission_type: form.commission_type,
        commission_value: form.commission_value || null,
      }
      const saved = isEdit ? await updateHook.mutate(partner.id, payload) : await createHook.mutate(payload)
      toast({ title: isEdit ? "Partner updated" : "Partner created", description: saved.name })
      onSuccess?.()
      onClose()
    } catch (errors) {
      toast({ variant: "destructive", title: "Error", description: Array.isArray(errors) ? errors[0] : "Save failed" })
    }
  }

  const saving = createHook.isPending || updateHook.isPending

  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="right" className="flex flex-col p-0 sm:max-w-[480px]">
        <SheetHeader className="border-b border-slate-100 px-6 py-4">
          <SheetTitle>{isEdit ? form.name || "Channel partner" : "New channel partner"}</SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto px-6 py-5">
          <ChannelPartnerBasicsTab form={form} setForm={setForm} partner={partner} onSuccess={onSuccess} />
        </div>

        <div className="flex justify-end gap-2 border-t border-slate-100 px-6 py-4">
          <Button variant="outline" onClick={onClose} disabled={saving}>Cancel</Button>
          <Button onClick={handleSave} disabled={saving || !form.name || !form.referral_code}>{saving ? "Saving…" : "Save"}</Button>
        </div>
      </SheetContent>
    </Sheet>
  )
}
